<template>
  <div class="min-w-15rem">
    <div class="vue-report-filter-button app-sidebar-exclude btn-group btn-group-split">
      <AppButton
        type="primary"
        :disabled="isLoading"
        @click="onClick"
      >
        Filters
      </AppButton>
      <AppButton
        data-toggle="dropdown"
        type="primary"
        class="dropdown-toggle dropdown-toggle-split"
        :disabled="isLoading"
        @click="onDropdownClick"
      >
        <i class="hi hi-caret"></i>
        <span class="sr-only">Toggle dropdown</span>
      </AppButton>
      <div class="dropdown-menu dropdown-menu-right">
        <ReportSavedFilterList :show-actions="false" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'ReportFilterButton',
  emits: ['click'],
  computed: {
    ...mapState(['saved_report_filters', 'report_name']),
    ...mapGetters(['showLoading', 'showLoadingMore']),
    isLoading() {
      return this.showLoading || this.showLoadingMore;
    },
  },
  methods: {
    ...mapActions(['analyticsTrackReport']),
    onClick() {
      this.$emit('click');
    },
    onDropdownClick() {
      !$(this.$el).find('.vue-report-filter-button').hasClass('open') &&
        this.analyticsTrackReport({
          event: 'Filters saved dropdown opened',
          props: {
            saved_filters: this.saved_report_filters.length,
          },
        });
    },
  },
};
</script>
